let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iyPZw")).then(() => parcelRequire('cvbpu'));